import { FullValidationErrorFragment } from '@common/graphql/fragments';
import { gql } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql';
import { OFFER_INFO_DETAILS_FRAGMENT } from '@applicant-flow/graphql/fragments';

const CreateOfferMutation = gql`
  mutation CreateOfferMutation(
    $staffingRequestApplicationId: ID!
    $input: CreateOfferMutationInput!
    $deviated: Boolean
  ) {
    createOffer(
      staffingRequestApplicationId: $staffingRequestApplicationId
      input: $input
      deviated: $deviated
    ) {
      offer {
        id
        state
        workforceGroup {
          id
        }
        # Refetch parent application and all offers
        staffingRequestApplication {
          id
          state
          staffingRequest {
            id
            submittedStaffingRequestApplicationsCount
            inReviewStaffingRequestApplicationsCount
            offeredOffersStaffingRequestApplicationsCount
            acceptedStaffingRequestApplicationsCount
            withdrawnStaffingRequestApplicationsCount
            rejectedStaffingRequestApplicationsCount
          }
          activeOffers {
            id
            state
            stateChangedAt
            startDate
            endDate
            rejectionReason
            rejectionDetails
            billingRegularRate
            timeoffDescription
            shiftType
            shiftsPerWeek
            hoursPerShift
            createdAt
            history {
              ...HistoryInfoFragment
            }
          }
          activeOffer {
            id
            state
            stateChangedAt
            startDate
            endDate
            rejectionReason
            rejectionDetails
            billingRegularRate
            timeoffDescription
            shiftType
            shiftsPerWeek
            hoursPerShift
            createdAt
            staffingRequestAssignment {
              id
            }
            history {
              ...HistoryInfoFragment
            }
            # FIXME: fetch id to help with apollo cache
            # eslint-disable-next-line @graphql-eslint/strict-id-in-types
            ...OfferDetailsInfo
          }
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${HistoryInfoFragment}
  ${OFFER_INFO_DETAILS_FRAGMENT}
  ${FullValidationErrorFragment}
`;

export { CreateOfferMutation };
